import React,{useEffect,useContext,useState} from 'react';
import flexFanIcon from '../../assets/img/login-imgs/flexfan-logo.png'
import notifacationIcon from '../../assets/img/feed-imgs/navbar/notification.svg'
import navbarMenu from '../../assets/img/feed-imgs/navbar/menu.svg'
import massageIcon from '../../assets/img/feed-imgs/navbar/message.svg'
import globeIcon from '../../assets/img/feed-imgs/navbar/globe.svg'
import shopIcon from '../../assets/img/feed-imgs/navbar/shop.svg'
import cardIcon from '../../assets/img/feed-imgs/navbar/cart.svg'
import userNavIcon from '../../assets/img/feed-imgs/navbar/user-nav.svg'
import leftSiteMenu from '../../assets/img/feed-imgs/navbar/menu-left.svg'
import rightSiteMenu from '../../assets/img/feed-imgs/navbar/menu-right.svg'
import './MainMenu.css'
// import userIcon from '';
import { Link } from 'react-router-dom';
import { ShowHideSitebar } from './../../App';

const MainMenu = () => {
    // Open Card Modal 
    const [ openCardModal, setOpenCardModal ] = useState(false)
    const [ showHideSidebar, setShowHideSidebar ] = useContext(ShowHideSitebar);
    useEffect(()=>{
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'home';
        setPageName.home.left=false;
        setPageName.home.right=false;
        setShowHideSidebar(setPageName)
    },[])
    const toggleLeftRightSidebar =(whichSidebar, status)=>{ /** checking which sidebar to toggle left or right */
        const pageName = showHideSidebar.pageName
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus[pageName].left = status
            setShowHideSidebar(newStatus)
        }
        if(whichSidebar === 'right'){
            newStatus[pageName].right = status
            setShowHideSidebar(newStatus)
        }
    }
    const valueOfCart = localStorage.getItem("cartItem")
    return (
        <header className='sticky-top'>
            <nav className="navbar  navbar-light navbar-expand-lg navigation-clean-search custom-nav mb-4">
                <div className="container-fluid container-xxl">
                    <div className="col-12 col-lg-2 mb-lg-0 mb-2">
                        <div className='d-flex justify-content-between align-items-center'>
                            <Link to="/" className='navbar-brand'>
                                <img src={flexFanIcon} alt="" className="img-lg-fluid d-lg-block d-none" />
                                <img src={flexFanIcon} alt="" className="small-site-logo d-lg-none" />
                            </Link>
                            <div className='d-lg-none d-flex justify-content-between'>
                                <div className='small-search-icon me-3'>
                                    <i className='fa-solid fa-magnifying-glass'></i>
                                </div>
                              <div>
                                <img src={userNavIcon} alt="" />
                              </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-12 col-lg-10  text-end d-flex justify-content-between align-items-center gap-4">
                        <div className='d-lg-none'>
                            <img src={leftSiteMenu} alt=""  onClick={()=>toggleLeftRightSidebar("left", !showHideSidebar?.[showHideSidebar.pageName]?.left)}/>
                        </div> 
                        <form className="me-auto search-form w-100 d-none d-lg-block" target="_self">
                            <div className="d-flex align-items-center position-relative"><label className="form-label d-flex mb-0 position-absolute" htmlFor="search-field" style={{right: "4%"}}><i className="fa-solid fa-magnifying-glass" style={{cursor: "pointer",color: "#8e8e8e", fontSize: "20px", zIndex: "1"}}></i></label>
                            <input className="position-relative text-white border-none text-start w-100 rounded-pill px-3 border-0 px-2 modal_btn" type="search" id="search-field-2" name="search" placeholder="Search..." /></div>
                        </form>
                        <img src={notifacationIcon} alt="" />
                        <Link to="/chatroom"><img src={massageIcon} alt="" /></Link>
                        <img src={navbarMenu} alt="" className='d-none d-lg-block'/>
                        <img src={globeIcon} alt="" />
                        <img src={shopIcon} alt="" />
                        <img src={cardIcon} alt="" className='cursor-pointer cart-button' onClick={ () => setOpenCardModal(!openCardModal)  }/>
                            {
                                openCardModal && <div className='cart-box'>{valueOfCart}5456<span className="inner-cart"></span></div>
                            }
                        <a className="btn btn-light action-button p-0 d-none d-lg-block" role="button" href="#">
                            <img src={userNavIcon} alt="" />
                        </a>
                        <div className='right menu d-lg-none' onClick={()=>toggleLeftRightSidebar("right", !showHideSidebar?.[showHideSidebar.pageName]?.right)}>
                            <img src={rightSiteMenu} alt="" />
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default MainMenu;